var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12ZM10.3937 6.55073L8.91615 7.91667H17C17.4142 7.91667 17.75 8.25245 17.75 8.66667C17.75 9.08088 17.4142 9.41667 17 9.41667H8.91615L10.3937 10.7826C10.6979 11.0638 10.7165 11.5383 10.4353 11.8425C10.1542 12.1466 9.67966 12.1652 9.3755 11.8841L6.49088 9.21739C6.33732 9.07543 6.25 8.8758 6.25 8.66667C6.25 8.45754 6.33732 8.2579 6.49088 8.11594L9.3755 5.44927C9.67966 5.1681 10.1542 5.18673 10.4353 5.49088C10.7165 5.79504 10.6979 6.26955 10.3937 6.55073ZM14.6245 12.1159L17.5091 14.7826C17.6627 14.9246 17.75 15.1242 17.75 15.3333C17.75 15.5425 17.6627 15.7421 17.5091 15.8841L14.6245 18.5507C14.3203 18.8319 13.8458 18.8133 13.5647 18.5091C13.2835 18.205 13.3021 17.7304 13.6063 17.4493L15.0838 16.0833H7C6.58579 16.0833 6.25 15.7475 6.25 15.3333C6.25 14.9191 6.58579 14.5833 7 14.5833H15.0838L13.6063 13.2174C13.3021 12.9362 13.2835 12.4617 13.5647 12.1576C13.8458 11.8534 14.3203 11.8348 14.6245 12.1159Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrow);
export default __webpack_public_path__ + "static/media/swap-arrow.291bea4ed8131045d083ba865219a823.svg";
export { ForwardRef as ReactComponent };